import { Line } from '@models/line.model';
import { Tool } from "@app/tool/model/tool.model";
import { Reason } from "@models/reason.model";
import { User } from "@models/user.model";

export class Issue {

    public id: number;
    public line: Line;
    public tools: Tool[];
    public approvedTools: Tool[];
    public rejectedTools: Tool[];
    public removedBySystemTools: Tool[];
    public status: string;
    public description: string;
    public reason: Reason;
    public user: User;
    public createdAt: Date;
    public isReplacementOrdered: boolean;

    static mapLine(line = {}) {
        return new Line(line || {})
    }

    static mapTools = res => {
        if (res) {
            return res.map(tool => new Tool(tool || {}));
        }
        return [];
    };

    static mapReason(reason = {}) {
        return new Reason(reason || {});
    }

    static mapUser(user = {}) {
        return new User(user || {})
    }

    constructor(issue: any = {}) {
        this.id = issue.id || 0;
        this.createdAt = issue.createdAt || '';
        this.status = issue.status || '';
        this.line = Issue.mapLine(issue.line);
        this.tools = Issue.mapTools(issue.tools);
        this.approvedTools = Issue.mapTools(issue.approvedTools);
        this.rejectedTools = Issue.mapTools(issue.rejectedTools);
        this.removedBySystemTools = Issue.mapTools(issue.removedBySystemTools);
        this.description = issue.description || '';
        this.isReplacementOrdered = issue.isReplacementOrdered;
        this.reason = Issue.mapReason(issue.reason);
        this.user = Issue.mapUser(issue.user);
    }
}
